import ClipboardJS from './lib/clipboard'; // Import ClipboardJS

(() => {
    // Check if the element with class 'macaw-copy-link' exists
    const clipboardButton = document.querySelector('.macaw-copy-link');

    if (clipboardButton) {
    // If the element exists, execute the rest of the code
    (() => {
        // Initialize ClipboardJS
        new ClipboardJS('.macaw-copy-link');

        // Add a click event listener to the clipboard button
        clipboardButton.addEventListener('click', function (event) {
        event.preventDefault();

        // Trigger the copy action when the button is clicked
        clipboardButton.classList.add('copy-is-active');

        setTimeout(function () {
            clipboardButton.classList.remove('copy-is-active');
        }, 3000);
        });
    })();
    }

})();
